/**
 * Case-insensitive match: query tokens must all appear somewhere in the haystack strings.
 * @param {string} query
 * @param {string[]} haystackParts
 */
export function matchesSearch(query, haystackParts) {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return true;
  const tokens = q.split(/\s+/).filter(Boolean);
  const hay = haystackParts.map((s) => String(s ?? '').toLowerCase()).join(' ');
  return tokens.every((t) => hay.includes(t));
}
